import { config } from '@/config'

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

export const getScanAddressUrl = (address: string) => {
  const baseUrl = config.VITE_BRIDGELESS_SCAN_URL

  if (!baseUrl) return null

  return `${trimTrailingSlash(baseUrl)}/accounts/${address}`
}

export const getScanValidatorUrl = (validatorAddress: string) => {
  const baseUrl = config.VITE_BRIDGELESS_SCAN_URL

  if (!baseUrl) return null

  return `${trimTrailingSlash(baseUrl)}/validator/${validatorAddress}`
}
